module.exports = __webpack_public_path__ + "static/media/nezmah-logo.25133e30.png";